import { Component, OnInit } from '@angular/core';
import { ImageBannerComponent } from '../../components/image-banner/image-banner.component';
import { Router, NavigationEnd, RouterLink } from '@angular/router';
import { ServicesCirclesComponent } from '../../includes/services-circles/services-circles.component';
import { SeatBeltComponent } from '../../components/seat-belt/seat-belt.component';
import { MetaService } from '../../services/meta.service';

@Component({
  selector: 'pc-services',
  standalone: true,
  imports: [
    ImageBannerComponent,
    ServicesCirclesComponent,
    RouterLink,
    SeatBeltComponent,
  ],
  templateUrl: './services.component.html',
  styleUrl: './services.component.scss'
})
export class ServicesComponent implements OnInit {
  // Banner Image
  bannerImgUrl: string | undefined;

  constructor(
    private router: Router,
    private metaService: MetaService,
  ) {  }

  ngOnInit(): void {
    this.metaService.setMetadata('our-services');

    // Make sure we're at top of page
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        window.scrollTo(0, 0);
      }
    });
    
    // Banner Image
    this.bannerImgUrl = 'https://tsgblob.blob.core.windows.net/pc-haines/assets/images/home/slider-4';
  }
}
